module.exports = __webpack_public_path__ + "static/shape-three-b94b95d7010d1fe35fa4e01d2e65345d.png";